module.exports = __webpack_public_path__ + "static/media/warriors-silhouette.2e337af5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/warriors-silhouette.svg
// module id = 1338
// module chunks = 0